<template>
  <span
    class="city-name"
    @click="() => { showCitySelect = true }"
  >
    {{ cityInBefore }}
    <span class="city-name__arrow" />
  </span>
</template>

<script>
import { cityIn } from 'lvovich';

import { factory as citySelectFactory } from '../City/CitySelect.vue';


export default {
  name: 'OdpListCitySelect',
  props: {
    city: Object,
  },
  data() {
    return {
      showCitySelect: false,
    };
  },
  computed: {
    cityInBefore() {
      const cityName = this.city?.Name;
      if (!cityName) return '';
      // fix lvovich
      switch (cityName.toLowerCase()) {
        case 'горячий ключ':
          return 'Горячем ключе';
        case 'алма-ата':
          return 'Алма-Ате';
        case 'новогрудок':
          return 'Новогрудке';
        case 'каменец':
          return 'Каменце';
        case 'череповец':
          return 'Череповце';
        case 'электросталь':
          return 'Электростали';
        default:
          break;
      }
      return this.cityIn(cityName);
    },
  },
  watch: {
    showCitySelect(val) {
      if (val && this.citySelectDlg) {
        this.citySelectDlg.show();
      }
    },
    city(val) {
      if (val && this.citySelectDlg) {
        this.citySelectDlg.select(val, true);
      }
    },
  },
  created() {
    this.citySelectDlg = null;
  },
  mounted() {
    this.citySelectDlg = citySelectFactory();
    this.citySelectDlg.$on('select', (city) => {
      this.citySelectDlg.hide();

      this.$emit('select', city);
    });
    this.citySelectDlg.$on('hide', () => {
      this.showCitySelect = false;
    });
  },
  methods: {
    cityIn,
  },
};
</script>

<style lang="scss" scoped>
  .city-name__arrow {
    // eslint-disable-next-line
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyLjAwMDA0TDE0LjExNjUgMTIuNTQyN0wyNiAyLjAwMDA0IiBzdHJva2U9IiNFRDE2NTEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+);
    background-size: 100% 100%;
    width: 28px;
    height: 15px;
    transition: .3s all cubic-bezier(.4, 0, .6, 1);
    position: absolute;
    right: -38px;
    top: 18px;

    @media(max-width: 767px) {
      top: 11px;
    }
  }

  .city-name {
    &:hover {
      .city-name__arrow {
        -webkit-transform: rotate(-180deg);
        transform: rotate(-180deg);
      }
    }
  }
</style>
